export default __webpack_public_path__ + "static/media/theme-default.a9e28995.jpg";